import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

export const apiProvider = new BaseApi(DMS_MODULE, NAME);
